import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import { MenuItem } from '@dhl-ui/components'
import { SelectInput } from '@dhl/formik'
import { COUNTRIES } from '~/common/config/country'
import type { LabelValue } from '~/common/model'

type Props = {
  fieldName: string
  countries?: LabelValue[]
  onChangeCountryCode: (countryCode: string) => void
  disabled?: boolean
}

export const CountrySelect = ({ disabled, fieldName, countries, onChangeCountryCode }: Props) => {
  const { t } = useTranslation()
  const [field] = useField(fieldName)

  const handleChange = (countryCode: string) => {
    onChangeCountryCode(countryCode)
  }

  return (
    <SelectInput
      label={t('admin.organisationsPage.organisationForm.country')}
      disabled={disabled}
      fullWidth
      name={fieldName}
      value={field.value}
      onChange={handleChange}
      data-testid="country-select"
    >
      {(countries ?? COUNTRIES).map(({ label, value }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </SelectInput>
  )
}
